export const isEmptyObject = (value) => {
    return (value == null ||
        (typeof value === 'object' && Object.keys(value).length === 0));
};
//# sourceMappingURL=isEmptyObject.js.map
// @zapier/universal-layout@11.4.2 (c660b09a7)
